import { render, staticRenderFns } from "./assignHomeworkLook.vue?vue&type=template&id=1bf93ea4"
import script from "./assignHomeworkLook.vue?vue&type=script&lang=js"
export * from "./assignHomeworkLook.vue?vue&type=script&lang=js"
import style0 from "./assignHomeworkLook.vue?vue&type=style&index=0&id=1bf93ea4&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports